import Vue from 'vue'
import Router from 'vue-router'

import Activity from '@/page/activityShare/ActivityShare'
import Apply from '@/page/activityShare/Apply'
import Succeed from '@/page/activityShare/Succeed'

import personalCenter from '@/page/personalCenter'
import VipCenterShare from '@/page/vipCenter/VipCenterShare'
import course from '@/page/course'
import OpenApp from '@/page/openApp/OpenApp'
import Payment from '@/page/payment/Payment'
import MoreActivities from '@/page/MoreActivities'
import Registration from '@/page/Registration'
import Phone from '@/page/findPhone'
import Email from '@/page/findEmail'
import Recommend from '@/page/webRecommend'
import LecturerHomepage from '@/page/LecturerHomepage'
import NewInvitation from '@/page/NewInvitation'
import NewInformation from '@/page/NewInformation'
import ChaoFilm from '@/page/course/chaoFilm/ChaoFilm'
import EmeaAd from '@/page/emea/EmeaAd'
import EmeaAdBi from '@/page/emea/EmeaAdBi'
import PaySucceed from '@/page/emea/PaySucceed'
import Exam from '@/page/exam/Exam'
import ExamUserInfo from '@/page/exam/ExamUserInfo'
import ExamSubject from '@/page/exam/ExamSubject'
import ExamSucceed from '@/page/exam/ExamSucceed'
import Fpga from '@/page/fpga/Fpga'
import NewApply from '@/page/NewApply'
import NewSucceed from '@/page/NewSucceed'

// 活动
import EmcPublicity from '@/page/activity/emc/EmcPublicity'
import EmcCst from '@/page/activity/emc/EmcCst'
import SevenDays from '@/page/activity/SevenDays'
import SevenPcb from '@/page/activity/SevenPcb'
import Si from '@/page/activity/si/Si'
import SiPi from '@/page/activity/si/SiPi'
import PcbLayout from '@/page/activity/pcblayout/PcbLayout'

// 拼课
import CourseShare from '@/page/groupBooking/Course'
import InviteShare from '@/page/groupBooking/Invite'
import Participant from '@/page/groupBooking/Participant'
import GroupBookingSucceed from '@/page/groupBooking/GroupBookingSucceed'
import GroupBookingFailing from '@/page/groupBooking/GroupBookingFailing'
import GroupBookingEnd from '@/page/groupBooking/GroupBookingEnd'
import GroupBookingList from '@/page/groupBooking/GroupBookingList'
import Notice from '@/page/groupBooking/com/Notice'

// 助力
import AssistanceHomePage from '@/page/assistance/AssistanceHomePage'
import AssistanceInvite from '@/page/assistance/AssistanceInvite'
import Assistance from '@/page/assistance/Assistance'
import AssistanceShare from '@/page/assistance/AssistanceShare'
import Errors from '@/page/error/Error'

import AssistancesHomePage from '@/page/assistances/AssistanceHomePage'
import AssistancesInvite from '@/page/assistances/AssistanceInvite'
import Assistances from '@/page/assistances/Assistance'
import AssistancesShare from '@/page/assistances/AssistanceShare'

// 话题
import TopicPostShare from '@/page/topic/TopicPostShare'
import TopicShare from '@/page/topic/TopicShare'

// 留言板
import LeavingAMessage from '@/page/message/LeavingAMessage'
import WelfarShare from '@/page/attestation/WelfarShare'

// 产品
import ProductShare from '@/page/product/ProductShare'

// 个人主页
import PersonalCenterShare from '@/page/personal/PersonalCenterShare'

//收录
import EmbodyEnterprise from '@/page/embody/EmbodyEnterprise'
import EmbodyCollege from '@/page/embody/EmbodyCollege'

// 相关成员
import RelevanceStudent from '@/page/relevance/RelevanceStudent'

// 短息
import Spread from '@/page/note/Spread'

// 问题详情
import ProblemDetails from '@/page/problem/ProblemDetails'

// 答疑专家主页
import AnswerQuestions from '@/page/answerQuestions/AnswerQuestions'

// 地图
import Amap from '@/components/Amap'

import Details from '@/page/router/activityDetails'
import Guese from '@/page/router/activityGuese'
import Else from '@/page/router/activityElse'

Vue.use(Router)
let env = process.env.NODE_ENV
let isEmptyBase = process.env.VUE_APP_EMPTY_BASE == 'emptybase'
let base = ''
if (!isEmptyBase) {
  env == 'development' ? (base = '/m/devtest') : (base = '/pages/m')
}

export default new Router({
  base: base,
  routes: [
    {
      path: '/assistanceHome',
      name: 'AssistanceHomePage',
      component: AssistanceHomePage
    },
    {
      path: '/assistanceInvite',
      name: 'AssistanceInvite',
      component: AssistanceInvite
    },
    {
      path: '/assistance',
      name: 'Assistance',
      component: Assistance
    },
    {
      path: '/assistanceShare',
      name: 'AssistanceShare',
      component: AssistanceShare
    },
    {
      path: '/assistancesHome',
      name: 'AssistancesHomePage',
      component: AssistancesHomePage
    },
    {
      path: '/assistancesInvite',
      name: 'AssistancesInvite',
      component: AssistancesInvite
    },
    {
      path: '/assistances',
      name: 'Assistances',
      component: Assistances
    },
    {
      path: '/assistancesShare',
      name: 'AssistancesShare',
      component: AssistancesShare
    },
    {
      path: '/emc',
      name: 'emcPublicity',
      component: EmcPublicity
    },
    {
      path: '/cst',
      name: 'EmcCst',
      component: EmcCst
    },
    {
      path: '/seven',
      name: 'SevenDays',
      component: SevenDays
    },
    {
      path: '/pcb',
      name: 'SevenPcb',
      component: SevenPcb
    },
    {
      path: '/si',
      name: 'Si',
      component: Si
    },
    {
      path: '/pcblayout',
      name: 'PcbLayout',
      component: PcbLayout
    },
    {
      path: '/personalCenterShare',
      name: 'personalCenterShare',
      component: personalCenter.Share
    },
    {
      path: '/vipCenterShare',
      name: 'vipCenterShare',
      meta: {
        title: '电巢VIP会员'
      },
      component: VipCenterShare
    },
    {
      path: '/activity',
      component: Activity,
      name: 'Activity',
      children: [{
        path: 'details',
        component: Details,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'guese',
        component: Guese,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'else',
        component: Else,
        meta: {
          keepAlive: false
        }
      }]
    },
    // 线下签到活动
    {
      path: '/activitySigned',
      name: 'ActivitySigned',
      meta: {
        title: '活动签到'
      },
      component: () => import('@/page/activitySigned/ActivitySigned')
    },
    {
      path: '/activitySignedSuccess',
      name: 'ActivitySignedSuccess',
      meta: {
        title: '活动签到'
      },
      component: () => import('@/page/activitySigned/ActivitySignedSuccess')
    },
    {
      path: '/apply',
      name: 'Apply',
      component: Apply,
      props: {
        newsletterPopup: false
      }
    },
    {
      path: '/more',
      name: 'More',
      meta: {
        title: '活动'
      },
      component: MoreActivities
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        title: '电巢登录'
      },
      component: () => import('@/page/login/PublicLogin')
    },
    {
      path: '/registration',
      name: 'Registration',
      meta: {
        title: '电巢登录'
      },
      component: Registration
    },
    {
      path: '/openCourseShare',
      name: 'openCourseShare',
      component: course.OpenCourseShare
    },
    {
      path: '/elaborateCourseShare',
      name: 'elaborateCourseShare',
      component: course.ElaborateCourseShare
    },
    {
      path: '/openApp',
      name: 'openApp',
      component: OpenApp
    },
    {
      path: '/redirect',
      name: 'redirect',
      component: () => import('@/page/openApp/Redirect')
    },
    {
      path: '/payment',
      name: 'payment',
      component: Payment,
      meta: {
        title: '确认订单'
      }
    },
    {
      path: '/succeed',
      name: 'Succeed',
      meta: {
        title: '报名成功'
      },
      component: Succeed,
    },
    {
      path: '/amap',
      name: 'Amap',
      component: Amap,
    },
    {
      path: '/forgetPhone',
      name: 'Phone',
      component: Phone
    },
    {
      path: '/forgetEmail',
      name: 'Email',
      component: Email
    },
    {
      path: '/recommend',
      name: 'Recommend',
      meta: {
        title: '电巢'
      },
      component: Recommend
    },
    {
      path: '/homepage',
      name: 'homepage',
      meta: {
        title: '讲师主页'
      },
      component: LecturerHomepage
    },
    {
      path: '/invitation',
      name: 'invitation',
      meta: {
        title: '巢贴'
      },
      component: NewInvitation
    },
    {
      path: '/information',
      name: 'information',
      meta: {
        title: '资讯'
      },
      component: NewInformation
    },
    {
      path: '/cFilm',
      name: 'cFilm',
      component: ChaoFilm,
      meta: {
        title: '电巢短视频'
      }
    },
    {
      path: '/emeaad',
      name: 'EmeaAd',
      meta: {
        title: '零经验7天入门硬件设计'
      },
      component: EmeaAd
    },
    {
      path: '/common',
      name: 'EmeaAdBi',
      meta: {
        title: '零经验7天入门硬件设计'
      },
      component: EmeaAdBi
    },
    {
      path: '/paySucceed',
      name: 'paySucceed',
      meta: {
        title: '报名成功'
      },
      component: PaySucceed
    },
    {
      path: '/course',
      name: 'CourseShare',
      component: CourseShare
    },
    {
      path: '/invite',
      name: 'InviteShare',
      component: InviteShare
    },
    {
      path: '/baySucceed',
      name: 'GroupBookingSucceed',
      component: GroupBookingSucceed
    },
    {
      path: '/bayFailing',
      name: 'GroupBookingFailing',
      component: GroupBookingFailing
    },
    {
      path: '/bayEnd',
      name: 'GroupBookingEnd',
      component: GroupBookingEnd
    },
    {
      path: '/bayList',
      name: 'GroupBookingList',
      component: GroupBookingList
    },
    {
      path: '/notice',
      name: 'Notice',
      component: Notice
    },
    {
      path: '/participant',
      name: 'Participant',
      component: Participant
    },
    {
      path: '/exam',
      name: 'Exam',
      component: Exam
    },
    {
      path: '/user',
      name: 'ExamUserInfo',
      component: ExamUserInfo
    },
    {
      path: '/subject',
      name: 'ExamSubject',
      component: ExamSubject
    },
    {
      path: '/examSucceed',
      name: 'ExamSucceed',
      component: ExamSucceed
    },
    {
      path: '/fpga',
      name: 'Fpga',
      meta: {
        title: 'FPGA高薪就业实训营'
      },
      component: Fpga
    },
    {
      path: '/topicPost',
      name: 'TopicPostShare',
      component: TopicPostShare,
      meta: {
        title: '话题帖'
      }
    },
    {
      path: '/topic',
      name: 'TopicShare',
      component: TopicShare,
      meta: {
        title: '巢文'
      }
    },
    {
      path: '/aMessage',
      name: 'LeavingAMessage',
      component: LeavingAMessage,
      meta: {
        title: '留言板'
      }
    },
    {
      path: '/welfarShare',
      name: 'WelfarShare',
      component: WelfarShare,
      meta: {
        title: '福利中心'
      }
    },
    {
      path: '/product',
      name: 'ProductShare',
      component: ProductShare,
      meta: {
        title: '产品'
      }
    },
    {
      path: '/elecOM',
      name: 'PersonalCenterShare',
      component: PersonalCenterShare
    },
    {
      path: '/AMDXilinx',
      name: 'NewApply',
      meta: {
        title: 'AMD-Xilinx直播报名'
      },
      component: NewApply,
    },
    {
      path: '/AMDXilinxSucceed',
      name: 'NewSucceed',
      meta: {
        title: 'AMD-Xilinx直播报名'
      },
      component: NewSucceed,
    },
    {
      path: '/enterprise',
      name: 'EmbodyEnterprise',
      component: EmbodyEnterprise,
    },
    {
      path: '/college',
      name: 'EmbodyCollege',
      component: EmbodyCollege,
    },
    {
      path: '/relevance',
      name: 'RelevanceStudent',
      component: RelevanceStudent,
    },
    {
      path: '/spread',
      name: 'Spread',
      component: Spread,
    },
    {
      path: '/problemDetails',
      name: 'ProblemDetails',
      component: ProblemDetails,
    },
    {
      path: '/answerQuestions',
      name: 'AnswerQuestions',
      component: AnswerQuestions,
    },
    {
      path: '/error',
      name: 'Error',
      component: Errors,
    },
    {
      path: '/sipi',
      name: 'SiPi',
      component: SiPi
    },
    {
      path: '/customActivityHome',
      name: 'customActivity',
      component: () => import('@/page/customActivity/Home')
    },
    {
      path: '/customActivityForm',
      name: 'customActivityForm',
      component: () => import('@/page/customActivity/Form')
    },
    {
      path: '/customActivityDetails',
      name: 'customActivityDetails',
      component: () => import('@/page/customActivity/Details')
    },
    {
      path: '/customActivityPoster',
      name: 'customActivityPoster',
      component: () => import('@/page/customActivity/Poster')
    },
    {
      path: '/customActivityInvite',
      name: 'customActivityInvite',
      component: () => import('@/page/customActivity/Invite')
    },
    {
      path: '/customActivityInviteSucceed',
      name: 'customActivityInviteSucceed',
      component: () => import('@/page/customActivity/InviteSucceed')
    },
    {
      path: '/certificate',
      name: 'certificate',
      component: () => import('@/page/postCertificate/Certificate')
    },
    {
      path: '/certificateFileFor',
      name: 'certificateFileFor',
      component: () => import('@/page/postCertificate/CertificateFileFor')
    },
    {
      path: '/authenticationSucceed',
      name: 'authenticationSucceed',
      component: () => import('@/page/postCertificate/AuthenticationSucceed')
    },
    {
      path: '/eitia',
      name: 'eitia',
      component: () => import('@/page/activity/eitia/Eitia')
    },
    {
      path: '/eitiaHome',
      name: 'eitiaHome',
      component: () => import('@/page/activity/eitia/EitiaHome')
    },
    {
      path: '/eitiaOnLine',
      name: 'eitiaOnLine',
      component: () => import('@/page/activity/eitia/EitiaOnLine')
    },
    {
      path: '/eitiaOnLineHome',
      name: 'eitiaHomeOnLine',
      component: () => import('@/page/activity/eitia/EitiaHomeOnLine')
    },
    {
      path: '/eitiaSignIn',
      name: 'eitiaSignIn',
      component: () => import('@/page/activity/eitia/EitiaSignIn')
    },
      // 培训计划分享页面
    {
      path: '/training',
      name: 'Training',
      component: () => import('@/page/training/Training')
    },
    // 培训计划-课程分享页面
    {
      path: '/trainingCourse',
      name: 'TrainingCourse',
      component: () => import('@/page/trainingCourse/Course')
    },
    // 空页面
    {
      path: '/learningEmpty',
      name: 'learningEmpty',
      // 懒加载
      component: () => import('@/page/training/learningEmpty')
    },
      // 专家详情分享页面
    {
      path: '/expertDetails',
      name: 'ExpertDetails',
      component: () => import('@/page/details/Expert')
    },
    // 知识点详情分享页面
    {
      path: '/knowledgePointsDetails',
      name: 'KnowledgePointsDetails',
      component: () => import('@/page/details/KnowledgePoints')
    },
    {
      path: '/sailWind',
      name: 'sailWind',
      component: () => import('@/page/activity/sailWind/SailWind')
    },
    {
      path: '/sailWindForm',
      name: 'sailWindForm',
      component: () => import('@/page/activity/sailWind/SailWindForm')
    },
    {
      path: '/sailWindSucceed',
      name: 'sailWindSucceed',
      component: () => import('@/page/activity/sailWind/SailWindSucceed')
    },
    {
      path: '/hardwareDesign',
      name: 'hardwareDesign',
      component: () => import('@/page/activity/hardwareDesign/HardwareDesign')
    },
    {
      path: '/hardwareDesignStage',
      name: 'hardwareDesignStage',
      component: () => import('@/page/activity/hardwareDesign/HardwareDesignStage')
    },
    {
      path: '/hardwareDesignerTrain',
      name: 'hardwareDesignerTrain',
      component: () => import('@/page/activity/hardwareDesign/HardwareDesignerTrain')
    },
    {
      path: '/allegroDesign',
      name: 'allegroDesign',
      component: () => import('@/page/activity/allegro/AllegroDesign')
    },
    {
      path: '/rf',
      name: 'rf',
      component: () => import('@/page/activity/rf/RadioFrequency')
    },
  ]
})
